import React, { Component, Fragment, useRef } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { DateRange } from "react-date-range";
import {
  Button,
  Form,
  AutoComplete,
  Select,
  Spin,
  Badge,
  Modal,
  Input,
  Icon,
  TimePicker as AntdTimePicker,
} from "antd";
import LangContext from "modules/shared/context/langContext";
import { genDeviceProcessDetail } from "modules/monitoring/honeytoastdownloadfile/components/deviceProcessFunc";
import { getOS } from "../../../shared/components/GetOS";

const FormItem = Form.Item;
const { Option, OptGroup } = AutoComplete;

const os = getOS();

const TimePicker = ({ value, style, onChange, ...other }) => {
  const timeInputRef = useRef(null);

  const isWindows = os === "Windows";

  const handleClick = () => {
    if (timeInputRef.current) {
      if (timeInputRef.current.focus) timeInputRef.current.focus(); // best you can do on iOS
      if (timeInputRef.current.click) timeInputRef.current.click(); // must be user-initiated
      if (timeInputRef.current.showPicker) timeInputRef.current.showPicker();
    }
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {isWindows ? (
        <AntdTimePicker
          value={moment(value, "HH:mm:ss")}
          onChange={(value) => {
            onChange({
              target: { value: value ? value.format("HH:mm:ss") : "00:00:00" },
            });
          }}
          style={{ ...style }}
          {...other}
        />
      ) : (
        <>
          <Input
            value={value}
            type="text"
            readOnly
            onClick={handleClick}
            style={{ ...style, zIndex: 2 }}
            suffix={<Icon type="clock-circle" onClick={handleClick} />}
            {...other}
          />
          <input
            ref={timeInputRef}
            className="without"
            type="time"
            step="1"
            style={{
              position: "absolute",
              opacity: 0,
              left: 0,
              top: 0,
              zIndex: 0,
            }}
            onChange={onChange}
          />
        </>
      )}
    </div>
  );
};

const TimePickerRange = ({ values, onChange }) => {
  const [startTime, endTime] = values;

  const handleChange = (type, value) => {
    if (type === "start") {
      let [hour, minute, second] = [0, 0, 0];
      if (value !== "") [hour, minute, second] = value.split(":").map(Number);

      if (second === null || second === undefined) second = 0;

      const updatedStart = moment(startTime).set({ hour, minute, second });
      onChange([updatedStart, endTime]);
    } else {
      let [hour, minute, second] = [23, 59, 59];
      if (value !== "") [hour, minute, second] = value.split(":").map(Number);

      if (second === null || second === undefined) second = 59;

      const updatedEnd = moment(endTime).set({ hour, minute, second });
      onChange([startTime, updatedEnd]);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "16px",
        marginBottom: "8px",
      }}
    >
      <TimePicker
        style={{
          width: "100%",
          minWidth: 0,
          WebkitAppearance: "none", // Disable default iOS style
          appearance: "none",
        }}
        value={moment(startTime).format("HH:mm:ss")}
        onChange={(e) => handleChange("start", e.target.value)}
      />
      <p>~</p>
      <TimePicker
        style={{
          width: "100%",
          minWidth: 0,
          WebkitAppearance: "none", // Disable default iOS style
          appearance: "none",
        }}
        value={moment(endTime).format("HH:mm:ss")}
        onChange={(e) => handleChange("end", e.target.value)}
      />
    </div>
  );
};

export default class Filter extends Component {
  state = {
    platenolists: [],
    device_type: "",
    firmware_version: 0,
    open: false,
  };

  handleOpenDeviceProcessModal = () => {
    let html = genDeviceProcessDetail(this.props.deviceProcess.userList);

    Modal.warning({
      title: "อุปกรณ์นี้ กำลังมีการเชื่อมต่อการใช้งานวีดีโอดังนี้",
      content: <div dangerouslySetInnerHTML={{ __html: html }}></div>,
      okText: "ปิด",
    });
  };

  changeVehiclePlateno = (value, option, setFieldValue) => {
    setFieldValue("plate_no", value);
    setFieldValue("old_format", "");
    setFieldValue("imei", "");
    setFieldValue("vehicle_id", "");

    if (typeof option !== "undefined") {
      setFieldValue(
        "should_show_fileopt",
        this.convertToBoolean(option.props.data_otp)
      );
      setFieldValue(
        "has_file_opt",
        this.convertToBoolean(option.props.data_otp)
      );
      setFieldValue("device_types_id", option.props.data_type);
    } else {
      setFieldValue("should_show_fileopt", false);
      setFieldValue("has_file_opt", false);
      setFieldValue("device_types_id", "");
    }

    setFieldValue("file_size", "large");
    setFieldValue("camera_position", "");
  };

  selectVehiclePlateno = (value, option, setFieldValue) => {
    setFieldValue("plate_no", option.props.data_value);
    setFieldValue("imei", option.props.label);
    setFieldValue("vehicle_id", option.props.data_id);
    setFieldValue("old_format", option.props.data_format);

    setFieldValue("has_file_opt", this.convertToBoolean(option.props.data_otp));
    setFieldValue(
      "should_show_fileopt",
      this.convertToBoolean(option.props.data_otp)
    );
    setFieldValue("device_types_id", option.props.data_type);
    setFieldValue("file_size", "large");
    setFieldValue("camera_position", "");

    let rec = this.props.vehicleOnly.find((x) => x.imei === option.props.label);
    this.props.setCameraChannel(rec.camera_channel);

    let temp = option.props.data_device_code.split("_");
    let temp_firmware_version = option.props.data_firmware_version.split("_");
    this.setState({
      device_type: temp[0],
      firmware_version: Number(temp_firmware_version[0]),
    });

    //this.props.loadLastestFileVehicle(option)
  };

  generateCameraOption = (imei) => {
    if (imei === "") {
      return this.defaultCameraOption();
    }

    let rec = this.props.vehicleOnly.find((x) => x.imei === imei);

    if (typeof rec === "undefined") {
      return this.defaultCameraOption();
    } else if (rec.camera_channel.length > 0) {
      let list = [{ index: "", name: "ทั้งหมด" }, ...rec.camera_channel];

      return list.map((x) => {
        return (
          <Option key={x.index.toString()} value={x.index.toString()}>
            {x.name}
          </Option>
        );
      });
    }

    return this.defaultCameraOption();
  };

  defaultCameraOption = () => {
    let list = [
      { value: "", label_index: "a", label: "all" },
      { value: "front", label_index: "f", label: "front" },
      { value: "back", label_index: "c", label: "camera_back" },
      { value: "extra", label_index: "c", label: "camera_extra" },
    ];

    return list.map((x) => {
      return (
        <Option key={x.value} value={x.value}>
          <LangContext.Consumer>
            {(i18n) => i18n[x.label_index][x.label]}
          </LangContext.Consumer>
        </Option>
      );
    });
  };

  convertToBoolean = (value) => {
    if (value === "true") {
      return true;
    }

    if (value === "false") {
      return false;
    }

    return value;
  };

  render() {
    const {
      onSubmit,
      vehicleLists,
      loadVehicle,
      deviceProcess,
      isMobile,
    } = this.props;

    const platenolists = vehicleLists
      .filter((x) => x.title !== "fileopt")
      .map((group) => (
        <OptGroup
          key={group.title}
          label={
            <span style={{ color: "blue" }}>
              <LangContext.Consumer>
                {(i18n) => i18n.o[group.title]}
              </LangContext.Consumer>
            </span>
          }
        >
          {group.children.map((opt) => {
            return (
              <Option
                key={`unique_key_${opt.imei}_${opt.id}`}
                label={opt.imei}
                data_value={opt.plate_no}
                data_id={opt.id}
                data_format={opt.old_format.toString()}
                data_otp={opt.has_file_opt.toString()}
                data_type={opt.device_types_id}
                data_device_code={opt.device_code}
                data_firmware_version={opt.firmware_version}
                disabled={group.title === "offline" ? true : false}
              >
                {group.title === "online" ? (
                  <Badge color="#00BF06" text={opt.plate_no} />
                ) : (
                  <Badge color="#c91c1c" text={opt.plate_no} />
                )}
              </Option>
            );
          })}
        </OptGroup>
      ));

    return (
      <Fragment>
        <Formik
          initialValues={this.props.reInitData}
          enableReinitialize
          validate={(values) => {
            let errors = {};
            if (values.eventdate.length > 0) {
              const date_start = moment(values.eventdate[0]["_d"]);
              const date_end = moment(values.eventdate[1]["_d"]);
              let day_diff = date_end.diff(date_start, "days") + 1;
              if (day_diff > 1) {
                errors.eventdate = "ช่วงวันที่ที่เลือกไม่ควรเกิน 1 วัน";
              }
            }
            return errors;
          }}
          validationSchema={yup.object().shape({
            plate_no: yup.string().required("กรุณาเลือกทะเบียนพาหนะ"),
            eventdate: yup.array().required("กรุณาเลือกช่วงวันที่"),
          })}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          render={({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            handleFocus,
            setFieldValue,
            resetForm,
          }) => (
            <Form onSubmit={handleSubmit} layout={"inline"}>
              <FormItem>
                <Button
                  type="danger"
                  disabled={deviceProcess === null}
                  icon="eye"
                  size="small"
                  onClick={this.handleOpenDeviceProcessModal}
                />
              </FormItem>

              <FormItem
                label={
                  <LangContext.Consumer>
                    {(i18n) => i18n.p.plateNo}
                  </LangContext.Consumer>
                }
                validateStatus={touched.plate_no && errors.plate_no && "error"}
                help={touched.plate_no && errors.plate_no}
                style={{
                  ...(isMobile && { width: "100%" }),
                }}
              >
                <AutoComplete
                  dataSource={platenolists}
                  optionLabelProp="children"
                  filterOption={(inputValue, option) => {
                    if (typeof option.props.children.props !== "undefined") {
                      return (
                        option.props.children.props.text
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) !== -1
                      );
                    }
                    return false;
                  }}
                  optionFilterProp="children"
                  placeholder="ค้นหาทะเบียน"
                  value={values.plate_no}
                  onFocus={this.props.loadData}
                  onSearch={(value, option) =>
                    this.changeVehiclePlateno(value, option, setFieldValue)
                  }
                  onSelect={(value, option) =>
                    this.selectVehiclePlateno(value, option, setFieldValue)
                  }
                  style={{
                    ...(!isMobile && { width: "300px" }),
                  }}
                  notFoundContent={loadVehicle ? <Spin size="small" /> : null}
                />
              </FormItem>

              <FormItem
                label={
                  <LangContext.Consumer>
                    {(i18n) => i18n.c.camera_position}
                  </LangContext.Consumer>
                }
                validateStatus={
                  touched.camera_position && errors.camera_position && "error"
                }
                help={touched.camera_position && errors.camera_position}
                style={{
                  ...(isMobile && { width: "100%" }),
                }}
              >
                <Select
                  onChange={(value) => {
                    setFieldValue("camera_position", value);
                    // กล้องหน้า hnt เท่านั้นที่มีไฟล์เล็ก
                    if (values.device_types_id == 32) {
                      if (
                        ["front", ""].includes(value) &&
                        values.has_file_opt
                      ) {
                        setFieldValue("should_show_fileopt", true);
                      } else {
                        setFieldValue("should_show_fileopt", false);
                        setFieldValue("file_size", "large");
                      }
                    }

                    if (values.device_types_id == 37) {
                      if (value === "extra") {
                        setFieldValue("should_show_fileopt", false);
                        setFieldValue("file_size", "large");
                      } else {
                        setFieldValue("should_show_fileopt", true);
                      }
                    }
                  }}
                  value={values.camera_position}
                  style={{ width: "100%" }}
                >
                  {this.generateCameraOption(values.imei)}
                </Select>
              </FormItem>

              {values.should_show_fileopt && (
                <FormItem
                  label={
                    <LangContext.Consumer>
                      {(i18n) => i18n.f.file_size}
                    </LangContext.Consumer>
                  }
                  style={{
                    ...(isMobile && { width: "100%" }),
                  }}
                >
                  <Select
                    onChange={(value) => setFieldValue("file_size", value)}
                    value={values.file_size}
                  >
                    <Option value="small">
                      <LangContext.Consumer>
                        {(i18n) => i18n.f.file_size_small}
                      </LangContext.Consumer>
                    </Option>
                    <Option value="large">
                      <LangContext.Consumer>
                        {(i18n) => i18n.f.file_size_large}
                      </LangContext.Consumer>
                    </Option>
                  </Select>
                </FormItem>
              )}

              <Form.Item
                label={
                  <LangContext.Consumer>
                    {(i18n) => i18n.d.dateRange}
                  </LangContext.Consumer>
                }
                validateStatus={errors.eventdate && "error"}
                help={errors.eventdate}
                style={{
                  ...(isMobile && { width: "100%" }),
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <Input
                    style={{ width: "100%", minWidth: "310px" }}
                    value={`${values.eventdate[0].format(
                      "DD/MM/YYYY HH:mm:ss"
                    )} ~ ${values.eventdate[1].format("DD/MM/YYYY HH:mm:ss")}`}
                    onClick={() => this.setState({ open: true })}
                  />

                  <Modal
                    visible={this.state.open}
                    title="เลือกช่วงเวลา"
                    onOk={() => this.setState({ open: false })}
                    onCancel={() => this.setState({ open: false })}
                    bodyStyle={{ padding: 0 }}
                  >
                    <DateRange
                      className="w-full"
                      ranges={[
                        {
                          startDate: values.eventdate[0].toDate(),
                          endDate: values.eventdate[1].toDate(),
                          key: "selection",
                        },
                      ]}
                      onChange={(ranges) => {
                        const { selection } = ranges;

                        // Parse selected start & end dates in UTC
                        const selectedStartUTC = moment
                          .utc(selection.startDate)
                          .local();

                        const selectedEndUTC = moment
                          .utc(selection.endDate)
                          .local();

                        // Clone the original start and end datetimes (preserving their time)
                        const originalStart = values.eventdate[0];
                        const originalEnd = values.eventdate[1];

                        // Update only the date part for start, keep original time
                        const updatedStart = originalStart
                          .year(selectedStartUTC.year())
                          .month(selectedStartUTC.month())
                          .date(selectedStartUTC.date());

                        // Update only the date part for end, keep original time
                        const updatedEnd = originalEnd
                          .year(selectedEndUTC.year())
                          .month(selectedEndUTC.month())
                          .date(selectedEndUTC.date());

                        // Set updated values
                        setFieldValue("eventdate", [updatedStart, updatedEnd]);
                      }}
                      showSelectionPreview={false}
                      showMonthAndYearPickers={false}
                      showDateDisplay={false}
                    />
                    <div style={{ paddingLeft: "8px", paddingRight: "12px" }}>
                      <TimePickerRange
                        values={values.eventdate}
                        onChange={(value) => setFieldValue("eventdate", value)}
                      />
                    </div>
                  </Modal>
                </div>
              </Form.Item>

              <FormItem
                style={{
                  ...(isMobile && {
                    width: "100%",
                    marginTop: "8px",
                  }),
                }}
              >
                <Button htmlType="submit" type="primary" block={isMobile}>
                  <LangContext.Consumer>
                    {(i18n) => i18n.a.apply}
                  </LangContext.Consumer>
                </Button>
              </FormItem>
              {/* <FormItem>
                {this.state.device_type == "ISU" &&
                this.state.firmware_version >= 20241225 ? (
                  <Button
                    onClick={() =>
                      this.props.loadLastestFileVehicle(
                        values.imei,
                        values.plate_no
                      )
                    }
                  >
                    แสดงไฟล์ทั้งหมด
                  </Button>
                ) : (
                  <></>
                )}
              </FormItem> */}
            </Form>
          )}
        />
      </Fragment>
    );
  }
}
